export function getVendorCode(env: string | undefined) {
  return env === 'production' ? '380860' : '136486'
}

export function getBenefitsWidgetConfig(
  vendorCode: string,
  t: (key: string, fallback: string) => string,
) {
  return {
    vendorCode,
    widgetType: 'identifier',
    pan: {
      label: t('sixteenDigitCardNumber', '16 digit card number'),
      placeholder: '0000 0000 0000 0000',
      borderRadius: '8px',
      fontSize: '16px',
      width: '100%',
      errorMessage: t(
        'invalidCardNumber',
        "Please enter a valid card number. Your card won't be charged",
      ),
    },
    panContainer: {
      width: '438px',
    },
    submit: {
      label: t('next', 'Check eligibility'),
      backgroundColor: '#2F80ED',
      color: '#ffffff',
      fontSize: '16px',
      borderRadius: '4px',
      width: '340px',
      errorMessage: t(
        'invalidCardNumberLength',
        "Enter all 16 digits of your card number. Your card won't be charged",
      ),
    },
    submitButton: {
      marginTop: '20px',
      width: '478px',
      display: 'flex',
      justifyContent: 'center',
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: 'auto',
    },
    widgetContainer: {
      width: '100%',
      maxWidth: '800px',
      backgroundColor: '#ffffff',
      border: 'none',
      margin: '0 auto 0 4px',
      padding: '0px',
      paddingTop: '0px',
    },
    label: {
      fontSize: '16px',
      fontWeight: '700',
    },
    layout: {
      fontFamily: "'Open Sans', sans-serif",
    },
    theme: {
      boxShadow: 'none',
    },
    container: {
      height: '180px',
    },
  }
}
